const NominationResults = () => import(/* webpackChunkName: "js/superadmin/home" */'@/views/superadmin/Nomination/Results');
const NominationPosts = () => import(/* webpackChunkName: "js/superadmin/home" */'@/views/superadmin/Nomination/NominationPosts');
const InternalNominationPosts = () => import(/* webpackChunkName: "js/superadmin/home" */'@/views/superadmin/Nomination/InternalNominationPosts');
const Nominees = () => import(/* webpackChunkName: "js/superadmin/home" */'@/views/superadmin/Nomination/Nominees');
const NominationPayments = () => import(/* webpackChunkName: "js/superadmin/home" */'@/views/superadmin/Nomination/NomPayments');
export default [
    {
        path: "/super-admin/nomination/results",
        component: NominationResults,
        name: "SuperAdminNominationResults",
    },
    {
        path: "/super-admin/nomination/posts",
        component: NominationPosts,
        name: "SuperAdminNominationPosts",
    },
    {
        path: "/super-admin/nomination/internal-posts",
        component: InternalNominationPosts,
        name: "SuperAdminInternalNominationPosts",
    },
    {
        path: "/super-admin/nomination/nominees",
        component: Nominees,
        name: "SuperAdminNominationNominees",
    },
    {
        path: "/super-admin/nomination/payments",
        component: NominationPayments,
        name: "SuperAdminNominationPayments",
    },
]
